// extracted by mini-css-extract-plugin
export var container = "styles-module__container___taSBh";
export var label = "styles-module__label___AZu9N";
export var body = "styles-module__body___eO0X8";
export var left = "styles-module__left___hY1W5";
export var right = "styles-module__right___ZSzQ1";